import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EditStateService {

  private isEditSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isEdit = this.isEditSubject.asObservable();

  changeState(state: boolean): void {
    this.isEditSubject.next(state);
  }

}
